import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Mission } from 'src/app/shared/models/mission/mission';

@Component({
	selector: 'app-selection-qualificator',
	templateUrl: './selection-qualificator.component.html',
	styleUrls: ['./selection-qualificator.component.scss']
})
export class SelectionQualificatorComponent implements OnInit {
	parcoursId: string;
	missionQualification: Mission;
	isValidateButtonClicked = false;

	employees: Employee[];
	selectedEmployee: Employee;

	constructor(private facade: FacadeService, public bsModalRef: BsModalRef) {}

	ngOnInit(): void {
		this.searchBestEmployees();
	}

	searchBestEmployees(): void {
		this.facade.parcoursService
			.searchBestEmployees(this.parcoursId)
			.subscribe((employees: Employee[]) => {
				this.employees = employees;
			});
	}

	selectEmployee(employee: Employee): void {
		this.selectedEmployee = employee;
	}

	validateEmployee(): void {
		this.isValidateButtonClicked = true;
		this.facade.parcoursService
			.postQualificator(this.parcoursId, this.selectedEmployee)
			.subscribe(() => {
				this.bsModalRef.hide();
			});
	}
}
